import { TIMEZONE_DEFAULT } from '@/client/services/dateTime'
import { PlatformDevice, PlatformRuntime } from '@/client/services/platform/constants'

import type { UserContextType } from './types'

// NOTE: NEVER make the default user id be null
// because for logged out users, this means skipping
// the user check in a lot of places, matching "any" so to say.
export const defaultUser: UserContextType = {
  id: 0,
  username: null,
  createdAt: new Date().toISOString(),
  uuidTranscript: '',
  uuidTraining: '',
  roles: [],
  worlds: {},
  channelIds: [],
  email: '',
  emailVerified: false,
  firstName: '',
  displayName: '',
  timezone: TIMEZONE_DEFAULT,
  avatarUrl: null,
  isLoggedOut: true,
  isOnboarding: false,
  country: '',
  ipAddress: null,
  tutorAuditorLevel: null,
  satBootcampStates: [],
  researchGroup: null,
  progression: {},
  progressionLevel: null,
  suspensionAction: null,
  notificationsLastViewedAt: null,
  platformRuntime: PlatformRuntime.web,
  platformDevice: PlatformDevice.DESKTOP,
  hasTutorProfile: false,
  hasAcceptedTutorTerms: false,
  dateOfBirth: null,
  ageAssuranceHistory: [],
}
